
import * as _ from 'lodash';
import { IApiUrls, Settings, IApiMethod } from '../models/utilitiesModel';

let apiurlsData: IApiUrls[] = [];
let appsetting: Settings;
const getApiServiceUrlByComponentAndMethod = (compName, methodName) => {
    let iapiMethods = _.pick(_.filter(apiurlsData, { component: compName })[0], ['methods']);
    let iapiMethod1 = (_.filter(iapiMethods['methods'], { name: methodName })[0]) as IApiMethod;
    let iapiMethod = { name: iapiMethod1.name, type: iapiMethod1.type, url: iapiMethod1.url } as IApiMethod
    return iapiMethod;
}
const setApiUrlsData = (data) => {
    apiurlsData = data;
}
const setAppsetting = (data: Settings) => {
    appsetting = data;
}
const getAppsetting = () => {
    return appsetting;
}
const gettranId = (modulesCode?: string) => {
    return modulesCode ? `${modulesCode}${Math.random().toString(36).slice(7)}` : (Math.random().toString(36).slice(7)) + '';
}

const getSessionTime = () => {
    return appsetting.SessionTime;
}
const getShowMessageTime = () => {
    return appsetting.showMessageTimeInsec;
}
const getDateTimeInterval = () => {
    return appsetting.dateTimeIntervalInmints;
}

const getSessionTimeout = () => {
    return appsetting.sessiontimeoutInsec;
}
const getTokenPrinttimeout = () => {
    return appsetting.tokenprinttimeoutInsec;
}
const getReaderRetriveInterval = () => {
    return appsetting.readerRetriveInterval;
}

const getIntervalCall = () => {
    return appsetting.intervalCallInmints;
}
const getReaderUrl = () => {
    return appsetting.readerUrl;
}
const getversionCheckInterval = (): number => {
    return appsetting.versionCheckInterval;
}
const getPrinterUrl = (): number => {
    return appsetting.printerUrl;
}
const getPromotionalUrl = (): string => {
    return appsetting.promotionalSlidesUrl;
}
const parseHtml = (html)=> {
    const parser = new DOMParser();
    return parser.parseFromString(html, "text/html"); // Return the parsed DOM object
}
const extractLinksToJson=(doc)=> {
    const links = doc.querySelectorAll("a"); // Select all <a> elements
    const files:any = [];
    links.forEach((link) => {
        const name = link.textContent;
        const href = link.getAttribute("href");
        // Skip "Parent Directory" or "../" links
        if (name === "Parent Directory" || href === "../") return;
        files.push(
            // name: name.endsWith("/") ? name.slice(0, -1) : name, // Remove trailing slash for directories
         href
            // type: name.endsWith("/") ? "directory" : "file",
        );
    });
    return files; // Return the array of JSON objects
}
export { getReaderRetriveInterval, getReaderUrl,getSessionTimeout,getTokenPrinttimeout, getDateTimeInterval,getIntervalCall, getSessionTime, getShowMessageTime, setAppsetting, getAppsetting, setApiUrlsData, getApiServiceUrlByComponentAndMethod, gettranId, getversionCheckInterval,getPrinterUrl,getPromotionalUrl,parseHtml,extractLinksToJson }
